import { render, staticRenderFns } from "./CreateDagontvangstModal.vue?vue&type=template&id=07c0867e"
import script from "./CreateDagontvangstModal.vue?vue&type=script&lang=ts"
export * from "./CreateDagontvangstModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c0867e')) {
      api.createRecord('07c0867e', component.options)
    } else {
      api.reload('07c0867e', component.options)
    }
    module.hot.accept("./CreateDagontvangstModal.vue?vue&type=template&id=07c0867e", function () {
      api.rerender('07c0867e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/CreateDagontvangstModal.vue"
export default component.exports